import React from 'react';
import { Select } from 'antd';

const SelectCampaignStatus = ({ showUninformed = true, ...rest }) => {
  return (
    <Select {...rest}>
      <Select.Option key="draft" value="draft">
        Rascunho
      </Select.Option>
      <Select.Option key="published" value="published">
        Publicado
      </Select.Option>
    </Select>
  );
};

export default SelectCampaignStatus;
